// extracted by mini-css-extract-plugin
export const portableText = "portableText-module--portableText--m2nT-";
export const darkBlock = "portableText-module--darkBlock--TY556";
export const compact = "portableText-module--compact--2DdWR";
export const checkList = "portableText-module--checkList--19Ifg";
export const checkListInline = "portableText-module--checkListInline--2xDBt";
export const docsBody = "portableText-module--docsBody--35zFq";